export * from './caption-editing.js';

const MB = 1024 * 1024;

export type SocialPostPlatform = 'instagram' | 'facebook' | 'linkedin';

export type SocialPostLimits = {
  imageMaxBytes: number;
  videoMaxBytes: number;
  videoMaxDurationSec: number;
  maxMediaCount: number;
};

// Conservative caps below each platform's documented maximum:
// - Instagram: 8 MB image / 300 MB Reels / 15 min — Reels-eligible window is 90s
// - Facebook (URL upload): 10 MB photo / 1 GB video / 20 min
// - LinkedIn: 36MP image / 500 MB video / 30 min
export const SOCIAL_POST_LIMITS: Record<SocialPostPlatform, SocialPostLimits> =
  {
    instagram: {
      imageMaxBytes: 8 * MB,
      videoMaxBytes: 100 * MB,
      videoMaxDurationSec: 90,
      maxMediaCount: 20,
    },
    facebook: {
      imageMaxBytes: 10 * MB,
      videoMaxBytes: 200 * MB,
      videoMaxDurationSec: 600,
      maxMediaCount: 10,
    },
    linkedin: {
      imageMaxBytes: 10 * MB,
      videoMaxBytes: 200 * MB,
      videoMaxDurationSec: 600,
      maxMediaCount: 1,
    },
  };

export const DEFAULT_MAX_MEDIA_COUNT = 1;

export const getMaxMediaCount = (platform: string | undefined): number =>
  platform
    ? (SOCIAL_POST_LIMITS[platform as SocialPostPlatform]?.maxMediaCount ??
      DEFAULT_MAX_MEDIA_COUNT)
    : DEFAULT_MAX_MEDIA_COUNT;

export type SocialPostDescriptionLimit = {
  label: string;
  max: number;
};

export const SOCIAL_POST_DESCRIPTION_MIN_LENGTH = 1;

export const SOCIAL_POST_DESCRIPTION_LIMITS: Record<
  SocialPostPlatform,
  SocialPostDescriptionLimit
> = {
  instagram: { label: 'Instagram', max: 2200 },
  facebook: { label: 'Facebook', max: 16_000 },
  linkedin: { label: 'LinkedIn', max: 3000 },
};
